import { render, staticRenderFns } from "./sprint-test.vue?vue&type=template&id=fc8dec72&scoped=true&"
import script from "./sprint-test.vue?vue&type=script&lang=js&"
export * from "./sprint-test.vue?vue&type=script&lang=js&"
import style0 from "./sprint-test.vue?vue&type=style&index=0&id=fc8dec72&scoped=true&lang=scss&"
import style1 from "./sprint-test.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8dec72",
  null
  
)

export default component.exports